import {useContext, useState} from 'react'
import {getFileIconClass, formatFileSize} from '../utils'
import {TicketDetailsPageContext} from '../context'
import {ConfirmationModal} from '../../../components/ConfirmationModal'

const ImageItem = ({apiImages, handleDeleteImage}: any) => {
  const {
    ticketId,
    projectId,
    onDeleteDocument,
    refetchAttachmentListing,
    isLoadingAttachmentListing,
    isLoadingOnDocumentUpload,
    hasTicketWritePermission,
    refetchHistory,
  } = useContext(TicketDetailsPageContext)
  const [hoverStates, setHoverStates] = useState<boolean[]>(new Array(apiImages.length).fill(false))
  const [imageAndIndex, setImageAndIndex] = useState<any>({image: null, index: null})
  const [showDeleteModal, setShowDeleteModal] = useState(false)

  const handleDownload = async (image: any) => {
    const fileName = image.file_name || 'file'
    const fileUrl = `${
      process.env.REACT_APP_IMAGE_URL
    }/admin/api/agile/projects/${projectId}/attachments/${ticketId}/${image?.relative_path
      ?.split('/')
      .pop()}`

    const response = await fetch(fileUrl, {
      headers: {
        'X-AUTH-TOKEN': '<your-token-here>',
      },
    })

    const blob = await response.blob()
    const blobUrl = window.URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = blobUrl
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(blobUrl)
  }

  const handleDelete = async () => {
    const fileName = imageAndIndex?.image?.relative_path?.split('/').pop()
    handleDeleteImage(imageAndIndex?.index)
    await onDeleteDocument(fileName)
    refetchAttachmentListing()
    refetchHistory()
  }

  const handleMouseEnter = (index: number) => {
    setHoverStates((prev) => {
      const newStates = [...prev]
      newStates[index] = true
      return newStates
    })
  }

  const handleMouseLeave = (index: number) => {
    setHoverStates((prev) => {
      const newStates = [...prev]
      newStates[index] = false
      return newStates
    })
  }

  return (
    <>
      <div className='d-flex flex-wrap gap-5'>
        {apiImages.map((image: any, index: number) => {
          return (
            <div
              key={index}
              className='file-item'
              onMouseEnter={() => handleMouseEnter(index)}
              onMouseLeave={() => handleMouseLeave(index)}
            >
              <div className='hover-group rounded border position-relative'>
                {hoverStates[index] && (
                  <div className='d-flex justify-content-between align-items-center position-absolute w-100 top-0 end-0 z-index-2'>
                    <div className='justify-content-end d-flex w-100 p-3 gap-3'>
                      <button
                        className='btn btn-sm btn-icon btn-light-primary w-30px h-30px'
                        onClick={() => handleDownload(image)}
                      >
                        <i className='bi bi-cloud-arrow-down fs-3'></i>
                      </button>
                      {hasTicketWritePermission && (
                        <button
                          className='btn btn-sm btn-icon btn-light-danger w-30px h-30px'
                          onClick={() => {
                            setShowDeleteModal(true)
                            setImageAndIndex({image, index})
                          }}
                        >
                          <i className='bi bi-trash fs-4'></i>
                        </button>
                      )}
                    </div>
                  </div>
                )}

                {image?.file_type !== 'attachment' ? (
                  <div className='w-150px h-125px p-4 d-flex flex-column justify-content-between'>
                    <div>
                      <i
                        className={`${getFileIconClass(image.file_name?.split('.').pop())} fs-3x`}
                      ></i>
                    </div>
                    <div className=''>
                      <p
                        className='fw-semibold text-truncate w-100 mb-2 lh-1'
                        title={image.file_name}
                      >
                        {image.file_name}
                      </p>
                      <div className='small text-muted fs-8'>
                        {image.file_size ? `${formatFileSize(image.file_size)}` : ''}
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className='w-150px h-125px p-3 position-relative'>
                      <div className='w-100 h-80px text-center overflow-hidden'>
                      <img
                        className='object-fit-cover w-100'
                        src={`${
                          process.env.REACT_APP_IMAGE_URL
                        }/admin/api/agile/projects/${projectId}/attachments/${ticketId}/${image?.relative_path
                          ?.split('/')
                          .pop()}?thumbnail=true`}
                        alt={image.file_name || `image-${index}`}
                        title={image.file_name}
                      />
                      </div>
                      <div className='position-absolute w-100 bottom-0 end-0 p-4'>
                        <div className='small text-muted fs-8'>
                          {image.file_size ? `${formatFileSize(image.file_size)}` : ''}
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          )
        })}
      </div>
      {showDeleteModal && (
        <ConfirmationModal
          show={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          onAction={handleDelete}
          body={
            <div>
              <p>Are you sure you want to remove this file?</p>
              <p>This action is permanently remove the file from the storage.</p>
            </div>
          }
          title='Delete File'
          isOperationLoading={isLoadingOnDocumentUpload}
          isDataLoading={isLoadingAttachmentListing}
        />
      )}
    </>
  )
}

export default ImageItem
